import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Button from '@mui/material/Button';
import { useNavigate, useLocation } from 'react-router-dom';

// Updated Icons
import DashboardIcon from '@mui/icons-material/Dashboard';
import FindInPageIcon from '@mui/icons-material/FindInPage';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

import { darken ,lighten, alpha} from '@mui/material/styles';
import { BASEURL,PRIMARYCOLOR,SECONDARYCOLOR,logoURL,COMPANY } from '../../Constants';

function Nav() {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedTab, setSelectedTab] = useState(0);

  // Split the pathname into segments.
  const segments = location.pathname.split("/");
  // Given the URL: /organization/dashboard/123, the org id is at index 3.
  const pentest_id = segments[3];

  // Determine selected tab based on URL
  useEffect(() => {
    if (location.pathname.match(/^\/organization\/dashboard\/\d+$/)) {
      setSelectedTab(0);
    } else if (location.pathname.match(/^\/organization\/pentests\/\d+$/)) {
      setSelectedTab(1);
    } else if (location.pathname.match(/^\/organization\/schedule\/\d+$/)) {
      setSelectedTab(2);
    } else {
      setSelectedTab(0); // Default to Dashboard if no match
    }
  }, [location.pathname]);

  // Handle tab change and navigate to the corresponding route
  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
    switch (newValue) {
      case 0:
        navigate(`/organization/dashboard/${pentest_id}`);
        break;
      case 1:
        navigate(`/organization/pentests/${pentest_id}`);
        break;
      case 2:
        navigate(`/organization/schedule/${pentest_id}`);
        break;
      default:
        break;
    }
  };

  return (
    <Box
      sx={{
        backgroundColor: 'white',
        padding: '10px',
        borderRadius: '10px',
        boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 12px',
        marginBottom: '20px',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '10px',
        }}
      >
        <Typography variant="h4" sx={{ fontWeight: 'bold' }}>
          Organization
        </Typography>

        {/* Blue outline button (top-right) */}
        <Button
          variant="outlined"
          onClick={() => navigate(`/pentests/create`)}
          sx={{
            borderColor: PRIMARYCOLOR,
            color: PRIMARYCOLOR,
            textTransform: 'none',
            fontWeight: 600,
            '&:hover': {
              borderColor: darken(PRIMARYCOLOR, 0.1),
              backgroundColor: alpha(PRIMARYCOLOR, 0.08),
            },
          }}
          endIcon={<OpenInNewIcon />}
        >
          New Pentest
        </Button>
      </Box>

      {/* Navigation Tabs */}
      <Tabs
        value={selectedTab}
        onChange={handleTabChange}
        aria-label="Navigation Tabs"
        textColor="primary"
        indicatorColor="primary"
      >
        <Tab icon={<DashboardIcon />} label="Dashboard" />
        <Tab icon={<FindInPageIcon />} label="Pentests" />
        <Tab icon={<CalendarMonthIcon />} label="Schedule" />
      </Tabs>
    </Box>
  );
}

export default Nav;
